// extracted by mini-css-extract-plugin
module.exports = {"tempNode":"TempNode_tempNode__2_9IA"};